import { getAccountBadgeFiltersEssential } from '../../../../backend/features/badges/shared';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { isValid, parseISO } from 'date-fns';
export function mapAccountBadgeFilter({ filterData, accountFilter, initialFilter, }) {
    const filter = initialFilter !== null && initialFilter !== void 0 ? initialFilter : [];
    filter.push(...getAccountBadgeFiltersEssential());
    if (filterData.status) {
        filter.push({
            column: 'status',
            op: 'in',
            value: filterData.status,
        });
    }
    if (filterData.distributionStatus) {
        filter.push({
            column: 'distributionStatus',
            op: 'in',
            value: filterData.distributionStatus,
        });
    }
    if (filterData.expiresAt) {
        const { from, to } = filterData.expiresAt;
        const fromDate = parseISO(from + 'T00:00:00.000');
        const toDate = parseISO(to + 'T23:59:59.999');
        if (isValid(fromDate)) {
            filter.push({
                column: 'expiresAt',
                op: '>=',
                value: fromDate.getTime(),
            });
        }
        if (isValid(toDate)) {
            filter.push({
                column: 'expiresAt',
                op: '<=',
                value: toDate.getTime(),
            });
        }
    }
    if (accountFilter && accountFilter.length > 0) {
        filter.push({
            column: 'accountId',
            op: 'in',
            subFilter: {
                entity: accountEntityName,
                filter: accountFilter,
            },
        });
    }
    return filter;
}
